/* eslint-disable react/jsx-no-comment-textnodes */
import type { ReactNode, ReactElement } from 'react';

// material
import { alpha, styled } from '@mui/material/styles';
import { ButtonGroup } from '@mui/material';

export interface MButtonGroupProps {
  children?: ReactNode;
  color?: string;
  variant?: any;
  [key: string]: any;
}

// ----------------------------------------------------------------------

// @ts-ignore legacy boundary
const ButtonGroupStyle = styled(ButtonGroup)(({ theme, styleProps }) => {
  const { color, variant } = styleProps;

  const styleContained = (color) => ({
    // @ts-ignore legacy boundary
    boxShadow: theme.customShadows[color],
    '& .MuiButtonGroup-grouped': {
      color: theme.palette[color].contrastText,
      backgroundColor: theme.palette[color].main,
      borderColor: `${theme.palette[color].dark} !important`,
      '&:hover': {
        backgroundColor: theme.palette[color].dark,
      },
    },
  });

  const styleOutlined = (color) => ({
    '& .MuiButtonGroup-grouped': {
      color: theme.palette[color].main,
      borderColor: `${alpha(theme.palette[color].main, 0.48)} !important`,
      '&:hover': {
        borderColor: `${theme.palette[color].main} !important`,
        backgroundColor: alpha(
          theme.palette[color].main,
          theme.palette.action.hoverOpacity
        ),
      },
    },
  });

  const styleText = (color) => ({
    '& .MuiButtonGroup-grouped': {
      color: theme.palette[color].main,
      borderColor: `${theme.palette[color].main} !important`,
      '&:hover': {
        backgroundColor: alpha(
          theme.palette[color].main,
          theme.palette.action.hoverOpacity
        ),
      },
    },
  });
  return {
    ...(variant === 'contained' && { ...styleContained(color) }),
    ...(variant === 'outlined' && { ...styleOutlined(color) }),
    ...(variant === 'text' && { ...styleText(color) }),
  };
});

// ----------------------------------------------------------------------

function MButtonGroup({
  color = 'primary',
  variant = 'outlined',
  children,
  ...other
}: MButtonGroupProps) {
  if (color === 'inherit' || color === 'primary' || color === 'secondary') {
    return (
      <ButtonGroup color={color} variant={variant} {...other}>
        {children}
      </ButtonGroup>
    );
  }

  return (
    <ButtonGroupStyle
      variant={variant}
      // @ts-ignore legacy boundary
      styleProps={{ color, variant }}
      {...other}
    >
      {children}
    </ButtonGroupStyle>
  );
}

export default MButtonGroup;
